import { createFileRoute, redirect } from '@tanstack/react-router'
import { SettingsRolesPermissions } from '@/views/roles-permissions'
import { useAuthStore } from '@/stores/authStore'

export const Route = createFileRoute('/_authenticated/cabinet-roles')({
    beforeLoad: () => {
        // Access store directly as it's not in route context provided by root
        const { auth } = useAuthStore.getState()

        if (!auth.accessToken || !auth.user) {
            throw redirect({
                to: '/auth/login',
            })
        }

        // Permission check
        // We check if user is admin OR has specific permission.
        const isAdmin = auth.user.is_admin === true;
        // can() is now added to AuthState interface
        const hasPermission = auth.can ? auth.can('api.view_role') : false;

        if (!isAdmin && !hasPermission) {
            throw redirect({
                to: '/',
            })
        }
    },
    component: SettingsRolesPermissions,
})
